import * as React from 'react';
import { connect } from 'react-redux';
import { ButtonProps } from 'semantic-ui-react';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Local Components
// @ts-ignore
import CurrentSeasonInProgressGate from 'components/CurrentSeasonInProgressGate';
// @ts-ignore
import ButtonLink from 'components/ButtonLink';

import { Roles } from 'components/RoleGate/types';
import RoleGate from 'components/RoleGate';

interface OwnProps {
    params: {
        [param: string]: any;
    };
    children: React.ReactNode;
    requiredRoles: Roles[];
    buttonProps?: ButtonProps;
}

interface DispatchProps {
    updateQueryString: Function;
}

export type Props = OwnProps & DispatchProps;

/**
 * A button component that adds params to qs when clicked, but only if you have permissions.
 */
export class RoleButtonLink extends React.PureComponent<Props> {
    handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
        event.stopPropagation();
        const { params } = this.props;
        this.props.updateQueryString(params);
    };

    render(): React.ReactElement | null {
        const { children, requiredRoles, buttonProps } = this.props;

        return (
            <RoleGate requiredRoles={requiredRoles}>
                <ButtonLink
                    buttonProps={buttonProps}
                    onClick={this.handleClick}
                >
                    {children}
                </ButtonLink>
            </RoleGate>
        );
    }
}

export default connect(null, { updateQueryString })(RoleButtonLink);
